import { requestType, SUPPLIER_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";

const getAllAttributesWithValues = (params) => {
    const url = SUPPLIER_ENDPOINTS.ATTRIBUTE.GET_ALL_ATTRIBUTES_WITH_VALUES;
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append("search", params.search);

    const finalUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;

    return Api(finalUrl, null, requestType.GET);
};

export { getAllAttributesWithValues };